export function customScrollbar() {
    const isDesktop = !this.isTouch;
    $(window).on("load", function () {
        let axis = $(".custom-scrollbar").hasClass("vertical") ? "y" : "x";

        $(".custom-scrollbar").mCustomScrollbar({
            axis: axis,
            autoExpandScrollbar: true,
            advanced: {autoExpandHorizontalScroll: true}
        });
    });
}


// WEBPACK FOOTER //
// ./assets/js/modules/custom-scrollbar.js